import Cookies from "js-cookie";

const isServer = typeof window === "undefined";
const cookieLocale = !isServer ? Cookies.get("locale") : undefined;
const basketCookie: any = !isServer ? Cookies.get("MyBasket") : undefined;
const cookieBasket = basketCookie ? JSON.parse(basketCookie) : [];

export let global = {
  site_url: process.env.NEXT_PUBLIC_PARIETTE_SITE_URL,
  api_url: process.env.NEXT_PUBLIC_PARIETTE_API_URL,
  site_token: process.env.NEXT_PUBLIC_PARIETTE_SITE_TOKEN || "",
  default_site: 'RjkMDdwF',
  company_token: process.env.NEXT_PUBLIC_PARIETTE_COMPANY_TOKEN || "",
  aysoft_token: process.env.NEXT_PUBLIC_PARIETTE_AYSOFT_TOKEN || "",
  locale: cookieLocale ?? process.env.NEXT_PUBLIC_PARIETTE_LOCALE ?? "de",
  cdn_url: "https://demapi.s3.eu-central-1.amazonaws.com/uploads/",
  authData: {
    authorizationType: "Bearer ", // don't remove last space if auth. type is Bearer
    authorizationKey: "access_token",
    authorizationExpires: 1 / 2,
    loginPage: "/Auth/Login",
    resetPage: "/Auth/Reset-password",
    loginRedirect: process.env.NEXT_PUBLIC_PARIETTE_SITE_TOKEN == process.env.NEXT_PUBLIC_PARIETTE_AYSOFT_TOKEN ? "/Dashboard" : "/Pins",
    me: "auth/user", // authorization control api endpoint
    refresh: "auth/refresh", // JWT refresh endpoint — 401 interceptor tarafından çağrılır
    register: "auth/register",
    login: "auth/aysoft-login",
    logout: "auth/logout",
    forgotPassword: "auth/forgot-password",
    resetPassword: "auth/reset-password",
    reSendVerification: "email/verification-notification",
  },
  errors: {
    anyError: {
      status: true,
      code: 500,
      title: "anyErrorTitle",
      message: "anyErrorMessage",
    },
    noError: { status: true, code: 200, title: "", message: "" },
  },
  basket: {
    basketKey: "MyBasket",
    defaultBasket: cookieBasket,
  },
  langList: [
    { code: "tr", flag: "🇹🇷", title: "Türkçe" },
    { code: "en", flag: "🇬🇧", title: "English" },
    { code: "de", flag: "🇩🇪", title: "Deutsch" },
  ],
};

export function setGlobal(newSettings: Partial<typeof global>) {
  global = { ...global, ...newSettings };
}

export const eshopNav = [
  {
    title: "Apple",
    link: "/WebShop/phone-c-ctkO4Lao?&brand=apple",
  },
  {
    title: "Samsung",
    link: "/WebShop/phone-c-ctkO4Lao?&brand=samsung",
  },
  {
    title: "Xiaomi",
    link: "/WebShop/phone-c-ctkO4Lao?&brand=xiaomi",
  },
];
